
// export const departments = [
//     {
//         id: 'web-development',
//         name: 'Web Development',
//         icon: 'FaGlobe',
//         color: '#667eea',
//         description: 'Web Development involves building and maintaining websites and web applications to ensure optimal performance and user experience.',
//         roles: [
//             {
//                 title: 'Frontend Developer',
//                 description: 'The Frontend Developer at the company handles the creation of responsive user interfaces using HTML, CSS, and JavaScript frameworks. They collaborate closely with designers to maintain brand consistency across all digital assets. Additionally, they implement reusable UI components to promote scalability, optimize web pages for maximum speed and performance, and ensure compatibility across various browsers and devices. They also integrate APIs to enable dynamic content rendering and are responsible for debugging and troubleshooting any front-end issues that arise.'
//             },
//             {
//                 title: 'Backend Developer',
//                 description: 'The Backend Developer manages server-side logic and API development within the company. They oversee databases, handling data storage and retrieval efficiently. Implementing secure authentication and authorization mechanisms is a key part of their role, along with optimizing server performance for scalability. They work in tandem with frontend developers to integrate services seamlessly, adhere to application security best practices, and debug and maintain backend services to ensure smooth operations.'
//             },
//             {
//                 title: 'UI/UX Designer',
//                 description: 'The UI/UX Designer conducts thorough user research to understand customer needs and preferences. They design wireframes, prototypes, and mockups focused on usability and intuitive interactions. Collaborating with developers, they bring designs to life while creating consistent design systems and style guides. They perform usability testing, gather feedback, and iterate on designs based on user insights to enhance the overall user experience in the company.'
//             },
//             {
//                 title: 'DevOps Engineer',
//                 description: 'The DevOps Engineer automates deployment pipelines using CI/CD tools to streamline processes. They monitor infrastructure and application performance, implement scalable cloud solutions, and manage containerization and orchestration with tools like Docker and Kubernetes. Ensuring system reliability and uptime is crucial, as is setting up logging and monitoring solutions. They collaborate with developers to optimize workflows and maintain efficient operations across the company.'
//             }
//         ]
//     },
//     {
//         id: 'mobile-app',
//         name: 'Mobile App',
//         icon: 'FaMobileAlt',
//         color: '#764ba2',
//         description: 'Mobile App Development focuses on creating native or cross-platform applications for iOS and Android devices, delivering seamless user experiences.',
//         roles: [
//             {
//                 title: 'Mobile App Developer',
//                 description: 'The Mobile App Developer builds native and cross-platform mobile applications tailored to user needs. They integrate backend APIs with mobile apps, apply mobile-friendly UI/UX principles, and optimize performance and battery usage. Conducting debugging and troubleshooting on various devices is essential, as is publishing and maintaining apps in app stores. They collaborate with designers and QA engineers to deliver high-quality mobile solutions in the company.'
//             },
//             {
//                 title: 'UI/UX Designer',
//                 description: 'The UI/UX Designer specializes in creating engaging mobile-first interfaces. They develop prototypes and user flows optimized for mobile experiences, ensuring designs are touch-friendly and accessible. Working with developers, they ensure seamless integration, conduct usability tests on different devices, and improve user engagement through thoughtful design. They also maintain consistent branding across all platforms within the company.'
//             },
//             {
//                 title: 'QA Engineer',
//                 description: 'The QA Engineer performs functional, integration, and regression testing on mobile apps. They write and execute test cases, ensure compatibility across devices and OS versions, and automate testing using frameworks like Appium. Reporting and tracking bugs throughout the lifecycle is key, as is collaborating with developers to resolve issues and validating app performance under various conditions to uphold quality standards in the company.'
//             },
//             {
//                 title: 'App Store Specialist',
//                 description: 'The App Store Specialist manages submissions and updates to app stores, optimizing listings with SEO-friendly content. They monitor app performance, ratings, and compliance with guidelines. Coordinating user acquisition and retention strategies, tracking analytics and usage metrics, and implementing monetization approaches are all part of their role in driving app success within the company.'
//             }
//         ]
//     },
//     {
//         id: 'ai-ml',
//         name: 'AI/ML Solutions',
//         icon: 'FaRobot',
//         color: '#f093fb',
//         description: 'AI/ML Solutions leverage artificial intelligence and machine learning to provide data-driven insights and automation for businesses.',
//         roles: [
//             {
//                 title: 'Data Scientist',
//                 description: 'The Data Scientist collects and preprocesses structured and unstructured data to build statistical and predictive models. They visualize insights using data tools and collaborate with business teams to define requirements. Deploying machine learning solutions into production, performing data cleaning and transformation, and monitoring model performance are critical responsibilities they handle in the company.'
//             },
//             {
//                 title: 'Machine Learning Engineer',
//                 description: 'The Machine Learning Engineer designs and trains ML models for automation and prediction tasks. They optimize algorithms for scalability, implement feature engineering, and deploy models in cloud or edge environments. Monitoring for model drift, retraining as needed, working with data scientists to scale solutions, and ensuring reproducibility in ML pipelines are key aspects of their role in the company.'
//             },
//             {
//                 title: 'AI Researcher',
//                 description: 'The AI Researcher explores new algorithms and techniques, publishing findings in journals and collaborating with universities and R&D teams. They prototype AI solutions for real-world challenges, focusing on areas like NLP, computer vision, or robotics. Developing experimental architectures and testing ethical AI applications are part of their innovative work in the company.'
//             },
//             {
//                 title: 'Data Analyst',
//                 description: 'The Data Analyst analyzes datasets to identify trends and patterns, preparing dashboards and reports for stakeholders. They assist in decision-making with actionable insights, clean raw data for reporting, and use tools like SQL, Excel, and BI software. Collaborating with data engineers for access pipelines and validating reporting metrics ensure accurate data-driven strategies in the company.'
//             }
//         ]
//     },
//     {
//         id: 'e-commerce',
//         name: 'E-commerce',
//         icon: 'FaShoppingCart',
//         color: '#4facfe',
//         description: 'E-commerce Development creates robust online stores with secure payment systems, user-friendly interfaces, and scalable architectures.',
//         roles: [
//             {
//                 title: 'E-commerce Developer',
//                 description: 'The E-commerce Developer builds and customizes e-commerce platforms, integrating secure payment gateways and developing product catalog and inventory systems. They ensure responsive shopping experiences, implement search and recommendation systems, troubleshoot store functionality, and collaborate with marketing teams to add features that enhance online retail operations in the company.'
//             },
//             {
//                 title: 'Payment Integration Specialist',
//                 description: 'The Payment Integration Specialist implements secure online payment solutions, working with providers like Stripe and PayPal. They ensure PCI-DSS compliance, troubleshoot transaction issues, implement fraud detection, maintain logs and monitoring, and optimize checkout flows to improve conversion rates within the company\'s e-commerce ecosystem.'
//             },
//             {
//                 title: 'SEO Specialist',
//                 description: 'The SEO Specialist optimizes website content for search engines, conducts keyword research for product listings, and improves rankings through link building. They monitor site analytics, collaborate with content writers for SEO-friendly text, implement technical improvements, and stay updated with algorithm changes to boost visibility and traffic for the company.'
//             },
//             {
//                 title: 'Digital Marketer',
//                 description: 'The Digital Marketer creates and manages online campaigns, optimizing for ROI and conversions. They run social media and email strategies, analyze performance with analytics tools, coordinate with SEO and content teams, implement retargeting, and manage paid ads across platforms like Google and Meta to drive growth in the company.'
//             }
//         ]
//     },
//     {
//         id: 'blockchain',
//         name: 'Blockchain',
//         icon: 'FaLink',
//         color: '#43e97b',
//         description: 'Blockchain Development builds secure, decentralized applications and smart contracts to enable trustless transactions and data integrity.',
//         roles: [
//             {
//                 title: 'Blockchain Developer',
//                 description: 'The Blockchain Developer develops decentralized applications (dApps), implements protocols and consensus algorithms, and integrates blockchain with web and mobile apps. They ensure transaction security, optimize network performance, test and deploy solutions, and collaborate with cryptographers and engineers to advance blockchain initiatives in the company.'
//             },
//             {
//                 title: 'Smart Contract Engineer',
//                 description: 'The Smart Contract Engineer writes and audits contracts using Ethereum and Solidity, ensuring they are secure and bug-free. They conduct unit and integration tests, optimize gas usage, deploy to testnet and mainnet, maintain documentation, and work with blockchain developers to support reliable smart contract functionality in the company.'
//             },
//             {
//                 title: 'Security Auditor',
//                 description: 'The Security Auditor performs audits on smart contracts and blockchain code, identifying vulnerabilities and recommending fixes. They monitor networks for suspicious activity, collaborate with developers on security patches, ensure compliance with standards, and conduct penetration tests to safeguard applications in the company.'
//             },
//             {
//                 title: 'DApp Developer',
//                 description: 'The DApp Developer builds decentralized applications using blockchain APIs, integrates smart contracts with frontend apps, and focuses on user-friendly Web3 interfaces. They implement wallet integrations like MetaMask, test across networks, collaborate with UI/UX teams for usability, and deploy and maintain dApps on blockchain platforms in the company.'
//             }
//         ]
//     },
//     {
//         id: 'consulting',
//         name: 'Consulting',
//         icon: 'FaBriefcase',
//         color: '#fa709a',
//         description: 'Consulting provides strategic guidance to optimize technology and business processes, ensuring alignment with organizational goals.',
//         roles: [
//             {
//                 title: 'Technology Consultant',
//                 description: 'The Technology Consultant advises organizations on optimal tech solutions, analyzes business processes for improvements, and recommends software and infrastructure enhancements. They collaborate on digital transformation, evaluate vendors, align tech with business goals, and provide training on new technologies to support the company\'s consulting services.'
//             },
//             {
//                 title: 'Business Analyst',
//                 description: 'The Business Analyst gathers and documents business requirements, bridges communication between stakeholders and developers, and creates functional specifications. They analyze workflows, propose improvements, ensure solutions meet needs, conduct feasibility studies and gap analysis, and support testing phases to facilitate effective project outcomes in the company.'
//             },
//             {
//                 title: 'Project Manager',
//                 description: 'The Project Manager plans, executes, and monitors projects, defining scope, goals, and deliverables. They manage team tasks and deadlines, oversee budget and resources, communicate progress to stakeholders, mitigate risks, and ensure timely delivery to maintain project success within the company.'
//             },
//             {
//                 title: 'Change Management Specialist',
//                 description: 'The Change Management Specialist guides organizations through transitions, develops strategies, and trains employees on new processes and tools. They communicate changes effectively, monitor adoption and feedback, identify and resolve resistance, and ensure smooth implementation of initiatives to support organizational change in the company.'
//             }
//         ]
//     }
// ];



// // Department-specific roadmap steps
// export const roadmapStepsData = {
//     'web-development': [
//         {
//             id: 1,
//             title: "Initial Consultation",
//             description: "Discuss your web project requirements and goals",
//             icon: "FaPhone",
//             duration: "1-2 days",
//             details: ["Project brief discussion", "Technology stack selection", "Timeline estimation"]
//         },
//         {
//             id: 2,
//             title: "Design & Planning",
//             description: "Create wireframes, mockups, and technical architecture",
//             icon: "FaPaintBrush",
//             duration: "5-7 days",
//             details: ["UI/UX design", "Database design", "API planning", "Responsive design"]
//         },
//         {
//             id: 3,
//             title: "Development Phase",
//             description: "Build your website with modern technologies",
//             icon: "FaLaptopCode",
//             duration: "2-8 weeks",
//             details: ["Frontend development", "Backend development", "Database implementation", "Third-party integrations"]
//         },
//         {
//             id: 4,
//             title: "Testing & Quality Assurance",
//             description: "Comprehensive testing across all devices and browsers",
//             icon: "FaFlask",
//             duration: "3-5 days",
//             details: ["Functionality testing", "Performance optimization", "Security testing", "Cross-browser testing"]
//         },
//         {
//             id: 5,
//             title: "Deployment & Launch",
//             description: "Deploy to production and go live",
//             icon: "FaRocket",
//             duration: "1-2 days",
//             details: ["Server setup", "Domain configuration", "SSL certificate", "Go-live checklist"]
//         },
//         {
//             id: 6,
//             title: "Maintenance & Support",
//             description: "Ongoing support and updates",
//             icon: "FaWrench",
//             duration: "Ongoing",
//             details: ["Bug fixes", "Content updates", "Performance monitoring", "Security updates"]
//         }
//     ],
//     'mobile-app': [
//         {
//             id: 1,
//             title: "App Strategy & Planning",
//             description: "Define app concept, target audience, and platform strategy",
//             icon: "FaListAlt",
//             duration: "3-5 days",
//             details: ["Market research", "User personas", "Platform selection", "Feature prioritization"]
//         },
//         {
//             id: 2,
//             title: "UI/UX Design",
//             description: "Create intuitive and engaging mobile interfaces",
//             icon: "FaPaintBrush",
//             duration: "7-10 days",
//             details: ["Wireframing", "Prototyping", "Visual design", "User testing"]
//         },
//         {
//             id: 3,
//             title: "App Development",
//             description: "Build native or cross-platform mobile application",
//             icon: "FaMobileAlt",
//             duration: "4-12 weeks",
//             details: ["Native development", "API integration", "Push notifications", "Offline functionality"]
//         },
//         {
//             id: 4,
//             title: "Testing & Optimization",
//             description: "Test across devices and optimize performance",
//             icon: "FaSearch",
//             duration: "5-7 days",
//             details: ["Device testing", "Performance optimization", "Bug fixing", "App store guidelines"]
//         },
//         {
//             id: 5,
//             title: "App Store Submission",
//             description: "Submit to app stores and manage approval process",
//             icon: "FaUpload",
//             duration: "3-7 days",
//             details: ["App store optimization", "Metadata preparation", "Review process", "Publication"]
//         },
//         {
//             id: 6,
//             title: "Post-Launch Support",
//             description: "Monitor performance and provide ongoing updates",
//             icon: "FaChartLine",
//             duration: "Ongoing",
//             details: ["Analytics monitoring", "User feedback", "Regular updates", "Feature enhancements"]
//         }
//     ],
//     'ai-ml': [
//         {
//             id: 1,
//             title: "Data Assessment",
//             description: "Analyze your data and define AI/ML objectives",
//             icon: "FaChartLine",
//             duration: "5-7 days",
//             details: ["Data quality analysis", "Problem definition", "Success metrics", "Data collection strategy"]
//         },
//         {
//             id: 2,
//             title: "Model Development",
//             description: "Build and train machine learning models",
//             icon: "FaBrain",
//             duration: "2-6 weeks",
//             details: ["Algorithm selection", "Model training", "Feature engineering", "Hyperparameter tuning"]
//         },
//         {
//             id: 3,
//             title: "Model Validation",
//             description: "Test and validate model performance",
//             icon: "FaCheckCircle",
//             duration: "3-5 days",
//             details: ["Cross-validation", "Performance metrics", "Bias detection", "Model comparison"]
//         },
//         {
//             id: 4,
//             title: "Integration & Deployment",
//             description: "Integrate AI solution into your existing systems",
//             icon: "FaLink",
//             duration: "1-2 weeks",
//             details: ["API development", "System integration", "Scalability setup", "Monitoring implementation"]
//         },
//         {
//             id: 5,
//             title: "Performance Monitoring",
//             description: "Monitor model performance and accuracy",
//             icon: "FaChartLine",
//             duration: "Ongoing",
//             details: ["Real-time monitoring", "Model drift detection", "Performance tracking", "Alert systems"]
//         },
//         {
//             id: 6,
//             title: "Continuous Improvement",
//             description: "Iterate and improve the AI solution",
//             icon: "FaSyncAlt",
//             duration: "Ongoing",
//             details: ["Model retraining", "Feature updates", "Performance optimization", "New data integration"]
//         }
//     ],
//     'e-commerce': [
//         {
//             id: 1,
//             title: "E-commerce Strategy",
//             description: "Define your online business strategy and requirements",
//             icon: "FaLightbulb",
//             duration: "3-5 days",
//             details: ["Business model analysis", "Target market research", "Competitor analysis", "Revenue projections"]
//         },
//         {
//             id: 2,
//             title: "Platform Selection",
//             description: "Choose the right e-commerce platform and technology",
//             icon: "FaShoppingCart",
//             duration: "2-3 days",
//             details: ["Platform comparison", "Custom vs. SaaS", "Payment gateway selection", "Hosting decisions"]
//         },
//         {
//             id: 3,
//             title: "Design & Development",
//             description: "Create your online store with custom features",
//             icon: "FaPaintBrush",
//             duration: "3-8 weeks",
//             details: ["Store design", "Product catalog setup", "Shopping cart", "Checkout process"]
//         },
//         {
//             id: 4,
//             title: "Payment & Security",
//             description: "Implement secure payment processing and security measures",
//             icon: "FaLock",
//             duration: "3-5 days",
//             details: ["Payment integration", "SSL certificates", "PCI compliance", "Security testing"]
//         },
//         {
//             id: 5,
//             title: "Testing & Launch",
//             description: "Test all functionality and launch your store",
//             icon: "FaRocket",
//             duration: "2-3 days",
//             details: ["End-to-end testing", "Performance optimization", "SEO setup", "Go-live preparation"]
//         },
//         {
//             id: 6,
//             title: "Marketing & Analytics",
//             description: "Set up marketing tools and analytics tracking",
//             icon: "FaChartLine",
//             duration: "Ongoing",
//             details: ["Analytics setup", "Marketing automation", "SEO optimization", "Conversion tracking"]
//         }
//     ],
//     'blockchain': [
//         {
//             id: 1,
//             title: "Blockchain Strategy",
//             description: "Define blockchain use case and technical requirements",
//             icon: "FaLink",
//             duration: "5-7 days",
//             details: ["Use case analysis", "Blockchain selection", "Consensus mechanism", "Token economics"]
//         },
//         {
//             id: 2,
//             title: "Smart Contract Development",
//             description: "Develop and test smart contracts",
//             icon: "FaFileContract",
//             duration: "2-4 weeks",
//             details: ["Contract architecture", "Code development", "Security audits", "Testing protocols"]
//         },
//         {
//             id: 3,
//             title: "DApp Development",
//             description: "Build decentralized application frontend and backend",
//             icon: "FaNetworkWired",
//             duration: "3-8 weeks",
//             details: ["Frontend development", "Web3 integration", "User interface", "Wallet integration"]
//         },
//         {
//             id: 4,
//             title: "Testing & Security",
//             description: "Comprehensive testing and security audits",
//             icon: "FaLock",
//             duration: "1-2 weeks",
//             details: ["Penetration testing", "Smart contract audits", "Vulnerability assessment", "Security hardening"]
//         },
//         {
//             id: 5,
//             title: "Deployment & Launch",
//             description: "Deploy to blockchain network and launch",
//             icon: "FaRocket",
//             duration: "2-3 days",
//             details: ["Mainnet deployment", "Node setup", "Network configuration", "Public launch"]
//         },
//         {
//             id: 6,
//             title: "Maintenance & Updates",
//             description: "Ongoing maintenance and feature updates",
//             icon: "FaWrench",
//             duration: "Ongoing",
//             details: ["Node maintenance", "Contract updates", "Performance monitoring", "Community support"]
//         }
//     ],
//     'consulting': [
//         {
//             id: 1,
//             title: "Initial Assessment",
//             description: "Evaluate your current technology and business processes",
//             icon: "FaSearch",
//             duration: "3-5 days",
//             details: ["Current state analysis", "Gap identification", "Stakeholder interviews", "Documentation review"]
//         },
//         {
//             id: 2,
//             title: "Strategy Development",
//             description: "Create comprehensive technology and business strategy",
//             icon: "FaListAlt",
//             duration: "5-7 days",
//             details: ["Strategic planning", "Technology roadmap", "Implementation timeline", "Resource allocation"]
//         },
//         {
//             id: 3,
//             title: "Solution Design",
//             description: "Design tailored solutions for your specific needs",
//             icon: "FaBullseye",
//             duration: "1-2 weeks",
//             details: ["Solution architecture", "Technology selection", "Process optimization", "Change management"]
//         },
//         {
//             id: 4,
//             title: "Implementation Planning",
//             description: "Create detailed implementation plan and timeline",
//             icon: "FaCalendarAlt",
//             duration: "2-3 days",
//             details: ["Project planning", "Resource allocation", "Risk assessment", "Milestone definition"]
//         },
//         {
//             id: 5,
//             title: "Execution Support",
//             description: "Provide guidance and support during implementation",
//             icon: "FaHandshake",
//             duration: "Ongoing",
//             details: ["Project management", "Technical guidance", "Team training", "Quality assurance"]
//         },
//         {
//             id: 6,
//             title: "Review & Optimization",
//             description: "Review results and optimize for continuous improvement",
//             icon: "FaChartLine",
//             duration: "Ongoing",
//             details: ["Performance review", "KPI analysis", "Process optimization", "Future planning"]
//         }
//     ]
// };


// export const departments = [
//     {
//         "id": "web-development",
//         "name": "Web Development",
//         "icon": "FaGlobe",
//         "color": "#667eea",
//         "description": "Web Development involves building and maintaining websites and web applications to ensure optimal performance and user experience.",
//         "roles": [
//             {
//                 "title": "Frontend Developer",
//                 "description": "The Frontend Developer handles creation of responsive user interfaces using HTML, CSS, and JavaScript frameworks. They collaborate with designers, implement reusable UI components, optimize performance, ensure cross-browser/device compatibility, integrate APIs, and debug front-end issues.",
//                 "checklist": [
//                     "Build responsive UIs with HTML/CSS/JS",
//                     "Create reusable UI components",
//                     "Integrate REST/GraphQL APIs",
//                     "Optimize performance and load times",
//                     "Ensure cross-browser & device compatibility",
//                     "Debug and troubleshoot front-end issues"
//                 ],
//                 "note": "Responsible for client-side experience, performance and debugging."
//             },
//             {
//                 "title": "Backend Developer",
//                 "description": "The Backend Developer manages server-side logic and API development, database design and queries, authentication/authorization, performance optimization, and collaboration with the frontend for API contracts and integration.",
//                 "checklist": [
//                     "Design and implement APIs",
//                     "Design database schemas and queries",
//                     "Implement authentication and authorization",
//                     "Optimize server performance and scalability",
//                     "Write unit/integration tests",
//                     "Monitor and maintain backend services"
//                 ],
//                 "note": "Responsible for server reliability, security and API contracts."
//             },
//             {
//                 "title": "UI/UX Designer",
//                 "description": "The UI/UX Designer performs user research, creates wireframes and high-fidelity prototypes, defines design systems, runs usability tests, and collaborates with developers to deliver accessible, consistent user experiences.",
//                 "checklist": [
//                     "Conduct user research and testing",
//                     "Produce wireframes and prototypes",
//                     "Create high-fidelity mockups",
//                     "Define design systems and style guides",
//                     "Validate designs through usability testing"
//                 ],
//                 "note": "Focuses on usability, accessibility and visual consistency."
//             },
//             {
//                 "title": "DevOps Engineer",
//                 "description": "The DevOps Engineer automates deployments and CI/CD pipelines, manages cloud infrastructure and containers (Docker/Kubernetes), sets up logging/monitoring/alerts, and ensures reliability and uptime.",
//                 "checklist": [
//                     "Implement CI/CD pipelines",
//                     "Manage cloud infrastructure and IaC",
//                     "Containerize apps and manage orchestration",
//                     "Set up monitoring, logging and alerts",
//                     "Ensure backup and recovery procedures"
//                 ],
//                 "note": "Ensures reliable deployments, uptime and operational tooling."
//             }
//         ]
//     },
//     {
//         "id": "mobile-app",
//         "name": "Mobile App",
//         "icon": "FaMobileAlt",
//         "color": "#764ba2",
//         "description": "Mobile App Development focuses on creating native or cross-platform applications for iOS and Android devices, delivering seamless user experiences.",
//         "roles": [
//             {
//                 "title": "Mobile App Developer",
//                 "description": "Builds native or cross-platform mobile apps, integrates backend APIs, optimizes performance and battery usage, debugs across devices, and publishes/maintains apps in stores.",
//                 "checklist": [
//                     "Develop native (iOS/Android) or cross-platform apps",
//                     "Integrate with backend APIs",
//                     "Optimize performance and battery usage",
//                     "Debug across devices and OS versions",
//                     "Publish and update apps on app stores"
//                 ],
//                 "note": "Responsible for building stable, performant mobile apps and store releases."
//             },
//             {
//                 "title": "UI/UX Designer",
//                 "description": "Designs mobile-first interactions, prototypes, and flows; ensures touch-friendly and accessible interfaces; performs usability testing on devices and collaborates with developers for implementation.",
//                 "checklist": [
//                     "Design mobile-first wireframes and prototypes",
//                     "Ensure touch-friendly UI and accessibility",
//                     "Conduct device usability testing",
//                     "Provide design specs for developers"
//                 ],
//                 "note": "Focuses on mobile usability and polished interactions."
//             },
//             {
//                 "title": "QA Engineer",
//                 "description": "Performs functional, integration, and regression testing on mobile apps, automates testing (e.g., Appium), ensures compatibility across devices/OS, tracks defects and validates fixes.",
//                 "checklist": [
//                     "Create and execute test cases",
//                     "Automate mobile tests where appropriate",
//                     "Validate app behavior across devices/OS versions",
//                     "Report and track bugs to resolution"
//                 ],
//                 "note": "Ensures mobile app quality and device compatibility."
//             },
//             {
//                 "title": "App Store Specialist",
//                 "description": "Manages app submissions, metadata and store optimization, monitors performance and ratings, ensures guideline compliance, and supports app marketing/monetization efforts.",
//                 "checklist": [
//                     "Prepare and submit app store metadata",
//                     "Optimize app listing (ASO)",
//                     "Monitor store performance and ratings",
//                     "Manage compliance and review responses"
//                 ],
//                 "note": "Handles app-store releases and listing performance."
//             }
//         ]
//     },
//     {
//         "id": "ai-ml",
//         "name": "AI/ML Solutions",
//         "icon": "FaRobot",
//         "color": "#f093fb",
//         "description": "AI/ML Solutions leverage artificial intelligence and machine learning to provide data-driven insights and automation for businesses.",
//         "roles": [
//             {
//                 "title": "Data Scientist",
//                 "description": "Collects and preprocesses data, builds statistical and predictive models, visualizes insights, and collaborates with stakeholders to deploy ML solutions and track model performance.",
//                 "checklist": [
//                     "Collect and preprocess structured/unstructured data",
//                     "Explore and visualize datasets",
//                     "Build and validate predictive models",
//                     "Collaborate on productionizing models",
//                     "Monitor model performance and drift"
//                 ],
//                 "note": "Bridges analytics, modeling and business requirements."
//             },
//             {
//                 "title": "Machine Learning Engineer",
//                 "description": "Designs, trains and optimizes ML models for production, implements feature engineering, containerizes models, deploys to cloud/edge, and ensures reproducibility in pipelines.",
//                 "checklist": [
//                     "Design and train ML models",
//                     "Implement feature engineering",
//                     "Package models for deployment",
//                     "Monitor and retrain models as needed",
//                     "Ensure reproducible ML pipelines"
//                 ],
//                 "note": "Focuses on scalable, reproducible model deployments."
//             },
//             {
//                 "title": "AI Researcher",
//                 "description": "Explores new algorithms, prototypes innovative solutions (NLP, CV, robotics), publishes findings, and collaborates with R&D teams to validate experimental approaches.",
//                 "checklist": [
//                     "Research novel ML/AI techniques",
//                     "Prototype experimental models",
//                     "Publish and document research findings",
//                     "Collaborate with academic and R&D partners"
//                 ],
//                 "note": "Drives research and experimental proof-of-concepts."
//             },
//             {
//                 "title": "Data Analyst",
//                 "description": "Analyzes datasets to identify trends, prepares dashboards and reports, cleans and validates data, and supports stakeholders with actionable insights.",
//                 "checklist": [
//                     "Clean and transform raw data",
//                     "Perform exploratory data analysis",
//                     "Create dashboards and reports",
//                     "Validate metrics and support decision-making"
//                 ],
//                 "note": "Provides operational insights and reporting for stakeholders."
//             }
//         ]
//     },
//     {
//         "id": "e-commerce",
//         "name": "E-commerce",
//         "icon": "FaShoppingCart",
//         "color": "#4facfe",
//         "description": "E-commerce Development creates robust online stores with secure payment systems, user-friendly interfaces, and scalable architectures.",
//         "roles": [
//             {
//                 "title": "E-commerce Developer",
//                 "description": "Builds and customizes e-commerce platforms, integrates payment gateways, implements catalog and inventory systems, search and recommendations, and collaborates with marketing for conversion improvements.",
//                 "checklist": [
//                     "Develop and customize store frontends and backends",
//                     "Integrate secure payment gateways",
//                     "Implement product catalog and inventory systems",
//                     "Add search and recommendation features",
//                     "Collaborate with marketing for conversions"
//                 ],
//                 "note": "Responsible for store functionality and checkout reliability."
//             },
//             {
//                 "title": "Payment Integration Specialist",
//                 "description": "Implements and maintains secure payment solutions (Stripe, PayPal), ensures PCI compliance, addresses transaction issues, and improves checkout UX to increase conversion.",
//                 "checklist": [
//                     "Integrate payment providers",
//                     "Ensure PCI-DSS and security best practices",
//                     "Implement fraud monitoring and prevention",
//                     "Troubleshoot transaction failures"
//                 ],
//                 "note": "Focuses on secure, reliable payment processing."
//             },
//             {
//                 "title": "SEO Specialist",
//                 "description": "Optimizes site and product content for search engines, performs keyword research, technical SEO improvements, monitors analytics and rankings to increase organic traffic.",
//                 "checklist": [
//                     "Perform keyword research for product listings",
//                     "Optimize on-page and technical SEO",
//                     "Monitor rankings and analytics",
//                     "Collaborate with content and product teams"
//                 ],
//                 "note": "Drives organic visibility and search traffic."
//             },
//             {
//                 "title": "Digital Marketer",
//                 "description": "Plans and runs acquisition campaigns (paid, email, social), tracks ROI, implements retargeting and analytics, and coordinates with SEO/content to increase conversions.",
//                 "checklist": [
//                     "Create and run paid acquisition campaigns",
//                     "Manage email and social campaigns",
//                     "Set up tracking and measure ROI",
//                     "Implement retargeting and CRO tactics"
//                 ],
//                 "note": "Responsible for growth, acquisition and campaign performance."
//             }
//         ]
//     },
//     {
//         "id": "blockchain",
//         "name": "Blockchain",
//         "icon": "FaLink",
//         "color": "#43e97b",
//         "description": "Blockchain Development builds secure, decentralized applications and smart contracts to enable trustless transactions and data integrity.",
//         "roles": [
//             {
//                 "title": "Blockchain Developer",
//                 "description": "Develops dApps, integrates blockchain with web/mobile, implements protocols and ensures transaction security, performance and integration with off-chain services.",
//                 "checklist": [
//                     "Build decentralized applications (dApps)",
//                     "Integrate blockchain with frontend/backends",
//                     "Implement protocols and consensus logic",
//                     "Test and optimize network performance"
//                 ],
//                 "note": "Focuses on building secure, integrated blockchain applications."
//             },
//             {
//                 "title": "Smart Contract Engineer",
//                 "description": "Writes and audits smart contracts (e.g., Solidity), conducts unit/integration tests, optimizes gas usage, deploys to testnet/mainnet and documents contract behavior.",
//                 "checklist": [
//                     "Write and test smart contracts",
//                     "Perform security audits and fixes",
//                     "Optimize gas and contract efficiency",
//                     "Deploy and manage contract versions"
//                 ],
//                 "note": "Ensures contracts are secure, correct and efficient."
//             },
//             {
//                 "title": "Security Auditor",
//                 "description": "Audits smart contracts and blockchain code for vulnerabilities, runs penetration tests, monitors networks, and recommends security fixes and best practices.",
//                 "checklist": [
//                     "Perform smart contract audits",
//                     "Run penetration and vulnerability tests",
//                     "Monitor network and suspicious activity",
//                     "Recommend and verify security patches"
//                 ],
//                 "note": "Protects applications from security vulnerabilities and exploits."
//             },
//             {
//                 "title": "DApp Developer",
//                 "description": "Builds user-friendly Web3 interfaces, integrates wallets (MetaMask), connects smart contracts with frontends, and tests across networks for usability and reliability.",
//                 "checklist": [
//                     "Implement wallet and Web3 integrations",
//                     "Connect frontend to smart contracts",
//                     "Test across networks and wallets",
//                     "Design user-friendly Web3 experiences"
//                 ],
//                 "note": "Bridges Web3 contracts with approachable user interfaces."
//             }
//         ]
//     },
//     {
//         "id": "consulting",
//         "name": "Consulting",
//         "icon": "FaBriefcase",
//         "color": "#fa709a",
//         "description": "Consulting provides strategic guidance to optimize technology and business processes, ensuring alignment with organizational goals.",
//         "roles": [
//             {
//                 "title": "Technology Consultant",
//                 "description": "Advises organizations on technical solutions, evaluates systems and vendors, recommends infrastructure and software improvements, and supports digital transformation efforts.",
//                 "checklist": [
//                     "Assess technical landscape and recommend solutions",
//                     "Evaluate vendors and technology choices",
//                     "Design transformation roadmaps",
//                     "Provide stakeholder training and governance"
//                 ],
//                 "note": "Helps align technology with business strategy."
//             },
//             {
//                 "title": "Business Analyst",
//                 "description": "Gathers and documents business requirements, maps workflows, performs feasibility and gap analyses, and translates business needs into functional specs for engineering teams.",
//                 "checklist": [
//                     "Gather and document business requirements",
//                     "Map and analyze workflows",
//                     "Create functional specifications",
//                     "Support testing and validation"
//                 ],
//                 "note": "Bridges stakeholders and engineering with clear requirements."
//             },
//             {
//                 "title": "Project Manager",
//                 "description": "Plans, executes and monitors projects—defining scope, milestones, budgets and resources—while mitigating risks and coordinating teams to deliver on time.",
//                 "checklist": [
//                     "Define project scope, goals and milestones",
//                     "Allocate resources and manage budgets",
//                     "Track progress and mitigate risks",
//                     "Communicate status to stakeholders"
//                 ],
//                 "note": "Accountable for on-time, on-budget project delivery."
//             },
//             {
//                 "title": "Change Management Specialist",
//                 "description": "Guides organizations through change by developing adoption strategies, training employees, monitoring progress and addressing resistance to ensure smooth transitions.",
//                 "checklist": [
//                     "Design change adoption strategies",
//                     "Develop training and communication plans",
//                     "Monitor adoption and feedback",
//                     "Address resistance and iterate plans"
//                 ],
//                 "note": "Ensures people adopt new processes and tools successfully."
//             }
//         ]
//     }
// ];
export const departments = [
    {
        "id": "web-development",
        "name": "Web Development",
        "icon": "FaGlobe",
        "color": "#667eea",
        "description": "Web Development builds and maintains websites and apps for great performance and user experience.",
        "roles": [
            {
                "title": "Frontend Developer",
                "description": "Creates user-friendly website interfaces using HTML, CSS, and JavaScript for smooth, responsive experiences.",
                "checklist": [
                    "Build responsive website layouts using HTML, CSS, JavaScript",
                    "Develop reusable interface components for consistent design",
                    "Connect APIs for dynamic website data integration",
                    "Improve website loading speed and performance",
                    "Ensure compatibility across browsers and devices",
                    "Identify and fix front-end technical issues"
                ],
                "note": "Creates fast, user-friendly website interfaces and resolves technical issues for better experiences."
            },
            {
                "title": "Backend Developer",
                "description": "Manages server logic, APIs, and databases for secure, scalable website functionality.",
                "checklist": [
                    "Create and maintain APIs for data exchange",
                    "Design efficient database structures and queries",
                    "Implement secure user login and access systems",
                    "Enhance server speed and handle high traffic",
                    "Write tests to ensure reliable code",
                    "Monitor and maintain server performance daily"
                ],
                "note": "Ensures secure, reliable server operations and smooth API integration for website functionality."
            },
            {
                "title": "UI/UX Designer",
                "description": "Designs intuitive, visually appealing interfaces through user research and prototypes for accessibility.",
                "checklist": [
                    "Conduct user research to understand needs",
                    "Create wireframes and interactive design prototypes",
                    "Design visually appealing, consistent mockups",
                    "Define reusable design systems and guidelines",
                    "Test designs for ease of use"
                ],
                "note": "Focuses on creating accessible, user-friendly, and visually consistent designs for websites."
            },
            {
                "title": "DevOps Engineer",
                "description": "Automates deployments, manages cloud systems, and ensures reliable, scalable website operations.",
                "checklist": [
                    "Set up automated website deployment processes",
                    "Manage cloud infrastructure for app hosting",
                    "Use containers to scale applications efficiently",
                    "Monitor performance with logs and alerts",
                    "Plan data backup and recovery strategies"
                ],
                "note": "Ensures smooth website deployments, reliable operations, and consistent uptime for users."
            }
        ]
    },
    {
        "id": "mobile-app",
        "name": "Mobile App",
        "icon": "FaMobileAlt",
        "color": "#764ba2",
        "description": "Mobile App Development creates user-friendly apps for iOS and Android devices.",
        "roles": [
            {
                "title": "Mobile App Developer",
                "description": "Builds mobile apps, connects to APIs, and ensures performance across devices.",
                "checklist": [
                    "Develop apps for iOS or Android platforms",
                    "Integrate APIs for app data connectivity",
                    "Optimize app speed and battery efficiency",
                    "Test apps on various mobile devices",
                    "Publish and update apps on stores"
                ],
                "note": "Builds stable, fast mobile apps and manages their release on app stores."
            },
            {
                "title": "UI/UX Designer",
                "description": "Designs mobile-friendly interfaces and prototypes for intuitive, accessible user interactions.",
                "checklist": [
                    "Design mobile-first layouts and prototypes",
                    "Ensure touch-friendly, accessible app interfaces",
                    "Test usability on different mobile devices",
                    "Provide clear design specs to developers"
                ],
                "note": "Creates intuitive, accessible mobile interfaces for smooth and engaging user experiences."
            },
            {
                "title": "QA Engineer",
                "description": "Tests mobile apps for functionality, compatibility, and reliability across devices.",
                "checklist": [
                    "Write and execute app test scenarios",
                    "Automate testing for faster quality checks",
                    "Verify app behavior on different devices",
                    "Track and resolve app bugs efficiently"
                ],
                "note": "Ensures mobile apps work reliably and consistently across devices and platforms."
            },
            {
                "title": "App Store Specialist",
                "description": "Manages app store submissions, optimizes listings, and ensures compliance with guidelines.",
                "checklist": [
                    "Prepare app store metadata and images",
                    "Optimize app listings for better visibility",
                    "Monitor app performance and user ratings",
                    "Handle compliance and store review processes"
                ],
                "note": "Manages app store presence and optimizes listings to reach more users effectively."
            }
        ]
    },
    {
        "id": "ai-ml",
        "name": "AI/ML Solutions",
        "icon": "FaRobot",
        "color": "#f093fb",
        "description": "AI/ML Solutions use data and algorithms to provide smart, automated business insights.",
        "roles": [
            {
                "title": "Data Scientist",
                "description": "Analyzes data, builds predictive models, and delivers insights for business decisions.",
                "checklist": [
                    "Collect and clean raw data for analysis",
                    "Visualize data to highlight key insights",
                    "Build accurate models to predict trends",
                    "Deploy models for practical business use",
                    "Monitor model performance and accuracy"
                ],
                "note": "Combines data analysis and modeling to provide actionable insights for businesses."
            },
            {
                "title": "Machine Learning Engineer",
                "description": "Builds and deploys scalable ML models for reliable, production-ready solutions.",
                "checklist": [
                    "Design and train machine learning models",
                    "Engineer features to improve model accuracy",
                    "Package models for deployment in systems",
                    "Monitor and update models for consistency",
                    "Ensure reliable machine learning pipeline processes"
                ],
                "note": "Builds and deploys scalable, reliable machine learning solutions for businesses."
            },
            {
                "title": "AI Researcher",
                "description": "Explores new AI techniques, prototypes solutions, and shares innovative findings.",
                "checklist": [
                    "Research new AI algorithms and techniques",
                    "Build experimental prototypes for AI solutions",
                    "Document and share research findings clearly",
                    "Collaborate with teams on innovative projects"
                ],
                "note": "Drives innovation by exploring and prototyping new AI solutions for future applications."
            },
            {
                "title": "Data Analyst",
                "description": "Analyzes data, creates reports, and provides insights for business decisions.",
                "checklist": [
                    "Clean and organize raw data sets",
                    "Analyze data to identify key trends",
                    "Create clear dashboards and detailed reports",
                    "Support decisions with accurate data insights"
                ],
                "note": "Provides clear, actionable data insights and reports to support business decisions."
            }
        ]
    },
    {
        "id": "e-commerce",
        "name": "E-commerce",
        "icon": "FaShoppingCart",
        "color": "#4facfe",
        "description": "E-commerce Development builds secure, user-friendly online stores with scalable systems.",
        "roles": [
            {
                "title": "E-commerce Developer",
                "description": "Builds online stores, integrates payments, and enhances shopping experiences.",
                "checklist": [
                    "Develop store frontends and backend systems",
                    "Integrate secure payment gateways for transactions",
                    "Build product catalogs and inventory systems",
                    "Add search and recommendation features",
                    "Support marketing to improve sales conversions"
                ],
                "note": "Ensures reliable online store functionality and smooth, secure checkout experiences."
            },
            {
                "title": "Payment Integration Specialist",
                "description": "Implements secure payment systems and ensures smooth, compliant transactions.",
                "checklist": [
                    "Set up secure payment gateway integrations",
                    "Follow security standards for safe transactions",
                    "Monitor transactions for fraud and errors",
                    "Resolve payment issues for smooth checkouts"
                ],
                "note": "Ensures secure, reliable payment processes for a seamless customer experience."
            },
            {
                "title": "SEO Specialist",
                "description": "Optimizes online store content for search engines to boost visibility.",
                "checklist": [
                    "Research keywords for better product visibility",
                    "Optimize website content and technical SEO",
                    "Track search rankings and website analytics",
                    "Collaborate with teams to improve content"
                ],
                "note": "Increases store visibility and traffic through better search engine rankings."
            },
            {
                "title": "Digital Marketer",
                "description": "Runs campaigns to attract customers and boost online store sales.",
                "checklist": [
                    "Plan paid ads and social media campaigns",
                    "Manage email marketing to engage customers",
                    "Track campaign performance and return on investment",
                    "Use retargeting to increase sales conversions"
                ],
                "note": "Drives customer acquisition and sales through targeted, effective marketing campaigns."
            }
        ]
    },
    {
        "id": "blockchain",
        "name": "Blockchain",
        "icon": "FaLink",
        "color": "#43e97b",
        "description": "Blockchain Development builds secure, decentralized apps for transparent transactions.",
        "roles": [
            {
                "title": "Blockchain Developer",
                "description": "Creates decentralized apps and integrates blockchain for secure transactions.",
                "checklist": [
                    "Build decentralized applications for blockchain networks",
                    "Connect blockchain to web or mobile apps",
                    "Implement secure transaction protocols and logic",
                    "Test and optimize blockchain network performance"
                ],
                "note": "Develops secure, efficient blockchain apps integrated with web and mobile systems."
            },
            {
                "title": "Smart Contract Engineer",
                "description": "Writes and tests smart contracts for secure, efficient blockchain operations.",
                "checklist": [
                    "Code and test secure smart contracts",
                    "Audit contracts to find security issues",
                    "Optimize contracts for efficient performance",
                    "Deploy and manage contract updates"
                ],
                "note": "Ensures secure, efficient smart contracts for reliable blockchain operations."
            },
            {
                "title": "Security Auditor",
                "description": "Checks blockchain code for vulnerabilities to ensure secure operations.",
                "checklist": [
                    "Audit smart contracts for security flaws",
                    "Run tests to identify vulnerabilities",
                    "Monitor blockchain network for suspicious activity",
                    "Recommend and verify security fixes"
                ],
                "note": "Protects blockchain apps from vulnerabilities and ensures secure, reliable operations."
            },
            {
                "title": "DApp Developer",
                "description": "Builds user-friendly blockchain interfaces and integrates wallets for accessibility.",
                "checklist": [
                    "Integrate wallets for blockchain app access",
                    "Connect frontends to smart contracts securely",
                    "Test apps across blockchain networks",
                    "Design intuitive interfaces for Web3 users"
                ],
                "note": "Creates accessible, user-friendly interfaces for blockchain apps and wallet integration."
            }
        ]
    },
    {
        "id": "consulting",
        "name": "Consulting",
        "icon": "FaBriefcase",
        "color": "#fa709a",
        "description": "Consulting guides businesses to optimize technology and achieve strategic goals.",
        "roles": [
            {
                "title": "Technology Consultant",
                "description": "Advises businesses on tech solutions to support growth and efficiency.",
                "checklist": [
                    "Assess current systems and business needs",
                    "Recommend technology solutions for efficiency",
                    "Plan strategies for digital transformation",
                    "Train teams on new tools and systems"
                ],
                "note": "Aligns technology with business goals to drive efficiency and growth."
            },
            {
                "title": "Business Analyst",
                "description": "Documents business needs and translates them into technical requirements.",
                "checklist": [
                    "Collect and document detailed business requirements",
                    "Analyze processes to identify improvements",
                    "Create specs for technical development teams",
                    "Support testing to validate solutions"
                ],
                "note": "Bridges business needs and technical teams with clear, actionable requirements."
            },
            {
                "title": "Project Manager",
                "description": "Leads projects, manages resources, and ensures timely, budgeted delivery.",
                "checklist": [
                    "Define project goals, scope, and timelines",
                    "Manage budgets and allocate team resources",
                    "Track progress and address project risks",
                    "Update stakeholders on project status regularly"
                ],
                "note": "Ensures projects are completed on time and within budget for success."
            },
            {
                "title": "Change Management Specialist",
                "description": "Guides teams through tech changes with training and support.",
                "checklist": [
                    "Plan strategies to adopt new changes",
                    "Create training and communication plans",
                    "Monitor adoption and collect feedback",
                    "Address resistance to ensure smooth transitions"
                ],
                "note": "Helps teams adopt new tools and processes effectively for successful change."
            }
        ]
    }
];

export const roadmapStepsData = {
    "web-development": [
        {
            "id": 1,
            "title": "Initial Consultation",
            "description": "Discuss your web project requirements and goals",
            "icon": "FaPhone",
            "duration": "1-2 days",
            "details": ["Project brief discussion", "Technology stack selection", "Timeline estimation"]
        },
        {
            "id": 2,
            "title": "Design & Planning",
            "description": "Create wireframes, mockups, and technical architecture",
            "icon": "FaPaintBrush",
            "duration": "5-7 days",
            "details": ["UI/UX design", "Database design", "API planning", "Responsive design"]
        },
        {
            "id": 3,
            "title": "Development Phase",
            "description": "Build your website with modern technologies",
            "icon": "FaLaptopCode",
            "duration": "2-8 weeks",
            "details": ["Frontend development", "Backend development", "Database implementation", "Third-party integrations"]
        },
        {
            "id": 4,
            "title": "Testing & Quality Assurance",
            "description": "Comprehensive testing across all devices and browsers",
            "icon": "FaFlask",
            "duration": "3-5 days",
            "details": ["Functionality testing", "Performance optimization", "Security testing", "Cross-browser testing"]
        },
        {
            "id": 5,
            "title": "Deployment & Launch",
            "description": "Deploy to production and go live",
            "icon": "FaRocket",
            "duration": "1-2 days",
            "details": ["Server setup", "Domain configuration", "SSL certificate", "Go-live checklist"]
        },
        {
            "id": 6,
            "title": "Maintenance & Support",
            "description": "Ongoing support and updates",
            "icon": "FaWrench",
            "duration": "Ongoing",
            "details": ["Bug fixes", "Content updates", "Performance monitoring", "Security updates"]
        }
    ],
    "mobile-app": [
        {
            "id": 1,
            "title": "App Strategy & Planning",
            "description": "Define app concept, target audience, and platform strategy",
            "icon": "FaListAlt",
            "duration": "3-5 days",
            "details": ["Market research", "User personas", "Platform selection", "Feature prioritization"]
        },
        {
            "id": 2,
            "title": "UI/UX Design",
            "description": "Create intuitive and engaging mobile interfaces",
            "icon": "FaPaintBrush",
            "duration": "7-10 days",
            "details": ["Wireframing", "Prototyping", "Visual design", "User testing"]
        },
        {
            "id": 3,
            "title": "App Development",
            "description": "Build native or cross-platform mobile application",
            "icon": "FaMobileAlt",
            "duration": "4-12 weeks",
            "details": ["Native development", "API integration", "Push notifications", "Offline functionality"]
        },
        {
            "id": 4,
            "title": "Testing & Optimization",
            "description": "Test across devices and optimize performance",
            "icon": "FaSearch",
            "duration": "5-7 days",
            "details": ["Device testing", "Performance optimization", "Bug fixing", "App store guidelines"]
        },
        {
            "id": 5,
            "title": "App Store Submission",
            "description": "Submit to app stores and manage approval process",
            "icon": "FaUpload",
            "duration": "3-7 days",
            "details": ["App store optimization", "Metadata preparation", "Review process", "Publication"]
        },
        {
            "id": 6,
            "title": "Post-Launch Support",
            "description": "Monitor performance and provide ongoing updates",
            "icon": "FaChartLine",
            "duration": "Ongoing",
            "details": ["Analytics monitoring", "User feedback", "Regular updates", "Feature enhancements"]
        }
    ],
    "ai-ml": [
        {
            "id": 1,
            "title": "Data Assessment",
            "description": "Analyze your data and define AI/ML objectives",
            "icon": "FaChartLine",
            "duration": "5-7 days",
            "details": ["Data quality analysis", "Problem definition", "Success metrics", "Data collection strategy"]
        },
        {
            "id": 2,
            "title": "Model Development",
            "description": "Build and train machine learning models",
            "icon": "FaBrain",
            "duration": "2-6 weeks",
            "details": ["Algorithm selection", "Model training", "Feature engineering", "Hyperparameter tuning"]
        },
        {
            "id": 3,
            "title": "Model Validation",
            "description": "Test and validate model performance",
            "icon": "FaCheckCircle",
            "duration": "3-5 days",
            "details": ["Cross-validation", "Performance metrics", "Bias detection", "Model comparison"]
        },
        {
            "id": 4,
            "title": "Integration & Deployment",
            "description": "Integrate AI solution into your existing systems",
            "icon": "FaLink",
            "duration": "1-2 weeks",
            "details": ["API development", "System integration", "Scalability setup", "Monitoring implementation"]
        },
        {
            "id": 5,
            "title": "Performance Monitoring",
            "description": "Monitor model performance and accuracy",
            "icon": "FaChartLine",
            "duration": "Ongoing",
            "details": ["Real-time monitoring", "Model drift detection", "Performance tracking", "Alert systems"]
        },
        {
            "id": 6,
            "title": "Continuous Improvement",
            "description": "Iterate and improve the AI solution",
            "icon": "FaSyncAlt",
            "duration": "Ongoing",
            "details": ["Model retraining", "Feature updates", "Performance optimization", "New data integration"]
        }
    ],
    "e-commerce": [
        {
            "id": 1,
            "title": "E-commerce Strategy",
            "description": "Define your online business strategy and requirements",
            "icon": "FaLightbulb",
            "duration": "3-5 days",
            "details": ["Business model analysis", "Target market research", "Competitor analysis", "Revenue projections"]
        },
        {
            "id": 2,
            "title": "Platform Selection",
            "description": "Choose the right e-commerce platform and technology",
            "icon": "FaShoppingCart",
            "duration": "2-3 days",
            "details": ["Platform comparison", "Custom vs. SaaS", "Payment gateway selection", "Hosting decisions"]
        },
        {
            "id": 3,
            "title": "Design & Development",
            "description": "Create your online store with custom features",
            "icon": "FaPaintBrush",
            "duration": "3-8 weeks",
            "details": ["Store design", "Product catalog setup", "Shopping cart", "Checkout process"]
        },
        {
            "id": 4,
            "title": "Payment & Security",
            "description": "Implement secure payment processing and security measures",
            "icon": "FaLock",
            "duration": "3-5 days",
            "details": ["Payment integration", "SSL certificates", "PCI compliance", "Security testing"]
        },
        {
            "id": 5,
            "title": "Testing & Launch",
            "description": "Test all functionality and launch your store",
            "icon": "FaRocket",
            "duration": "2-3 days",
            "details": ["End-to-end testing", "Performance optimization", "SEO setup", "Go-live preparation"]
        },
        {
            "id": 6,
            "title": "Marketing & Analytics",
            "description": "Set up marketing tools and analytics tracking",
            "icon": "FaChartLine",
            "duration": "Ongoing",
            "details": ["Analytics setup", "Marketing automation", "SEO optimization", "Conversion tracking"]
        }
    ],
    "blockchain": [
        {
            "id": 1,
            "title": "Blockchain Strategy",
            "description": "Define blockchain use case and technical requirements",
            "icon": "FaLink",
            "duration": "5-7 days",
            "details": ["Use case analysis", "Blockchain selection", "Consensus mechanism", "Token economics"]
        },
        {
            "id": 2,
            "title": "Smart Contract Development",
            "description": "Develop and test smart contracts",
            "icon": "FaFileContract",
            "duration": "2-4 weeks",
            "details": ["Contract architecture", "Code development", "Security audits", "Testing protocols"]
        },
        {
            "id": 3,
            "title": "DApp Development",
            "description": "Build decentralized application frontend and backend",
            "icon": "FaNetworkWired",
            "duration": "3-8 weeks",
            "details": ["Frontend development", "Web3 integration", "User interface", "Wallet integration"]
        },
        {
            "id": 4,
            "title": "Testing & Security",
            "description": "Comprehensive testing and security audits",
            "icon": "FaLock",
            "duration": "1-2 weeks",
            "details": ["Penetration testing", "Smart contract audits", "Vulnerability assessment", "Security hardening"]
        },
        {
            "id": 5,
            "title": "Deployment & Launch",
            "description": "Deploy to blockchain network and launch",
            "icon": "FaRocket",
            "duration": "2-3 days",
            "details": ["Mainnet deployment", "Node setup", "Network configuration", "Public launch"]
        },
        {
            "id": 6,
            "title": "Maintenance & Updates",
            "description": "Ongoing maintenance and feature updates",
            "icon": "FaWrench",
            "duration": "Ongoing",
            "details": ["Node maintenance", "Contract updates", "Performance monitoring", "Community support"]
        }
    ],
    "consulting": [
        {
            "id": 1,
            "title": "Initial Assessment",
            "description": "Evaluate your current technology and business processes",
            "icon": "FaSearch",
            "duration": "3-5 days",
            "details": ["Current state analysis", "Gap identification", "Stakeholder interviews", "Documentation review"]
        },
        {
            "id": 2,
            "title": "Strategy Development",
            "description": "Create comprehensive technology and business strategy",
            "icon": "FaListAlt",
            "duration": "5-7 days",
            "details": ["Strategic planning", "Technology roadmap", "Implementation timeline", "Resource allocation"]
        },
        {
            "id": 3,
            "title": "Solution Design",
            "description": "Design tailored solutions for your specific needs",
            "icon": "FaBullseye",
            "duration": "1-2 weeks",
            "details": ["Solution architecture", "Technology selection", "Process optimization", "Change management"]
        },
        {
            "id": 4,
            "title": "Implementation Planning",
            "description": "Create detailed implementation plan and timeline",
            "icon": "FaCalendarAlt",
            "duration": "2-3 days",
            "details": ["Project planning", "Resource allocation", "Risk assessment", "Milestone definition"]
        },
        {
            "id": 5,
            "title": "Execution Support",
            "description": "Provide guidance and support during implementation",
            "icon": "FaHandshake",
            "duration": "Ongoing",
            "details": ["Project management", "Technical guidance", "Team training", "Quality assurance"]
        },
        {
            "id": 6,
            "title": "Review & Optimization",
            "description": "Review results and optimize for continuous improvement",
            "icon": "FaChartLine",
            "duration": "Ongoing",
            "details": ["Performance review", "KPI analysis", "Process optimization", "Future planning"]
        }
    ]
};
